import { render, staticRenderFns } from "./AddEmployeeDocumentDetails.vue?vue&type=template&id=76af45ae&"
import script from "./AddEmployeeDocumentDetails.vue?vue&type=script&lang=js&"
export * from "./AddEmployeeDocumentDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76af45ae')) {
      api.createRecord('76af45ae', component.options)
    } else {
      api.reload('76af45ae', component.options)
    }
    module.hot.accept("./AddEmployeeDocumentDetails.vue?vue&type=template&id=76af45ae&", function () {
      api.rerender('76af45ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/hrmanagement/EmployeeManagement/EmployeeDetails/AddEmployeeDocumentDetails.vue"
export default component.exports